import React from "react";

const FAQHero: React.FC = () => {
  return (
    <section className="fq-hero lr-grain">
      <div className="fq-hero__orbs">
        <div className="fq-hero__orb fq-hero__orb--1" />
        <div className="fq-hero__orb fq-hero__orb--2" />
      </div>

      <div className="fq-hero__content">
        <span className="fq-hero__badge">
          <span />
          Help center
        </span>
        <h1 className="fq-hero__title">
          Frequently asked <span className="lr-text-gradient">questions</span>
        </h1>
        <p className="fq-hero__subtitle">
          Quick answers about file formats, templates, batch watermarking, subscriptions and the smart AI layout system.
        </p>
      </div>
    </section>
  );
};

export default FAQHero;
